module.exports = __webpack_public_path__ + "f23a96b1f5.bin";